import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setIsDoctorInfoPopupOpened, setSelectedDoctor } from '../../../../redux/features/hacker/users/doctorsAccess';
import GroupAccessList from './GroupAccessList';
import DoctorSettings from './DoctorSettings';
import DoctorUsage from './DoctorUsage';
import DoctorFinancials from './DoctorFinancials';
import DoctorLogs from './DoctorLogs';
import { setSelectedGroupAccess } from '../../../../redux/features/hacker/users/groupsAccess';
import CancelButton from '../../../general/inputs/CancelButton';
import Popup from '../../../general/popups/items/Popup';

interface Props { 

}; 

const DoctorInfo: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleQuit = () => { 

        dispatch(setSelectedGroupAccess(null)); 
        dispatch(setSelectedDoctor(null));         

        dispatch(setIsDoctorInfoPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Popup
            popupExtraStyle={{ 
                width: '80vw',
                height: '90vh',
                overflow: 'scroll', 
                overflowX: 'hidden', 
                padding: 1, 
            }}
        >

            <Box
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly', 
                    textAlign: 'center', 
                    width: '100%', 
                    maxHeight: 400, 
                    marginTop: 2, 
                    marginBottom: 3, 
                }}
            >

                <GroupAccessList />

                <DoctorSettings />

            </Box>

            <DoctorUsage />

            <DoctorFinancials />

            <DoctorLogs />

            <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

        </Popup>

  );

};

export default DoctorInfo;